import { connect } from 'react-redux';
import View from './DownPaymentView';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import {
  nullableHasPlanToGetMortgageSelector,
  alreadyHadMortgageSelector,
} from '../PlanToGetMortgage/PlanToGetMortgageSelector';
import nullableDownPaymentSelector from './DownPaymentSelector';

const mapStateToProps = (state, ownProps) => ({
  downPayment: nullableDownPaymentSelector(state, ownProps),
  hasPlanToGetMortgage: nullableHasPlanToGetMortgageSelector(state, ownProps),
  alreadyHadMortgage: alreadyHadMortgageSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onDownpaymentChanged: workflowId => ({ target: { value } }) => {
    let DownPayment = null;
    if (value !== '') {
      DownPayment = value;
    }
    dispatch(updateData(
      {
        [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
          DownPayment,
        },
      },
      workflowId,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
